function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import CSSclasses from '../../details.scss';
function getButtonColor(condition) {
  return condition ? 'primary' : 'default';
}
const classes = {
  root: classNames(CSSclasses.switchButton),
  outlinedPrimary: CSSclasses.switchButtonPrimary
};
export default function SwitchButton(_ref) {
  let {
      children,
      dataButton = '',
      isActive,
      onClick
    } = _ref,
    other = _objectWithoutProperties(_ref, ["children", "dataButton", "isActive", "onClick"]);
  return /*#__PURE__*/React.createElement(Button, _extends({
    "data-button": dataButton,
    variant: "outlined",
    onClick: onClick,
    color: getButtonColor(isActive),
    classes: classes
  }, other), children);
}